<script>
export default {
  methods: {
    getIEVersion() {
      const sAgent = window.navigator.userAgent;
      const Idx = sAgent.indexOf('MSIE');

      // If IE, return version number.
      if (Idx > 0) {
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)), 10);
      }

      if (navigator.userAgent.match(/Trident\/7\./)) {
        // If IE 11 then look for Updated user agent string.
        return 11;
      }

      return 0; // It is not IE
    }
  }
};
</script>
